import { AftermarketProductVendorApiChannel, CreditApplication, VendorProfile } from "@trnsact/trnsact-shared-types";
import { DynamicPricingInput, InsuranceQuoteFormValues } from "../types";
import { GaigBillingFrequency } from "@trnsact/aftermarket-vendor-sdk-gaig/dist/models/quote/program-codes/GaigBillingFrequency";
import { addMonths } from "date-fns";
import { v4 } from "uuid";
import { GAIG_CATEGORIES } from "../constants";

export const getTermArrayByStep = (min: number, max: number, step: number = 12): { value: string; label: string; }[] => {
  const termArray = [];

  if (min === 1) {
    termArray.push({ label: '1', value: '1' });
  }

  for (let i = min === 1 ? 12 : min; i <= max; i += step) {
    termArray.push({ label: i.toString(), value: i.toString() });
  }

  return termArray;
};

const generateContractNumber = (): string => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hour = String(now.getHours()).padStart(2, '0');
  const minute = String(now.getMinutes()).padStart(2, '0');
  const random = String(Math.floor(Math.random() * 10000)).padStart(4, '0');
  return `${month}${day}${hour}${minute}${random}`;
};

export const getDynamicPricingInput = (
  values: InsuranceQuoteFormValues,
  vendorProfile: VendorProfile,
  creditApplication?: CreditApplication
): DynamicPricingInput => {

  const assetCategory = GAIG_CATEGORIES.find(category => category.assetClass === values.availableAsset);
  const assetAmountToUseForDynamicPricing = creditApplication?.amountRequested ?? creditApplication?.equipments?.[0]?.retailPrice ?? 0;

  return {
    aftermarketVendorApiChannel: AftermarketProductVendorApiChannel.Gaig,
    gaigData: {
      input: {
        quote: {
          billingFrequency: values.billingFrequency as GaigBillingFrequency,
          contractStartDate: new Date(),
          contractEndDate: addMonths(new Date(), Number(values.contractTerm)),
          coverageStartDate: new Date(),
          coverageEndDate: addMonths(new Date(), Number(values.coverageTerm)),
          contractNumber: generateContractNumber(),
          userName: 'TRNSACT',
          customer: {
            customerName: creditApplication?.businessName ?? `${creditApplication?.firstName} ${creditApplication?.lastName}`,
            customerNumber: creditApplication?.id ?? '',
            customerAddress1: creditApplication?.address ?? '',
            customerAddress2: '',
            customerCity: creditApplication?.city ?? '',
            customerStateProv: values?.state ?? '',
            customerPostalCode: values?.postalCode ?? '',
            customerCountry: 'USA',
            customerContactEmail: creditApplication?.email ?? '',
            customerPhoneNumber: creditApplication?.phone ?? '',
          },
          vendor: {
            vendorName: vendorProfile.name ?? '',
            vendorNumber: vendorProfile.id ?? '',
          },
          assets: [
            {
              category: assetCategory?.category || values.availableAsset,
              assetAmount: assetAmountToUseForDynamicPricing,
              programCode: values.selectedProgram,
            },
          ],
        },
      },
    },
  }
};
